<template>
  <el-dialog
    title="选择服务费用"
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="handleClose">
    <el-table
      :data="chooseHousekeepingServFeeInfo.housekeepingServFees"
      border
      stripe
      style="width: 100%">
      <el-table-column prop="feeName" label="费用名称" align="center"></el-table-column>
      <el-table-column prop="typeName" label="费用大类" align="center"></el-table-column>
      <el-table-column prop="computingFormula" label="计算公式" align="center"></el-table-column>
      <el-table-column prop="feePrice" label="金额" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleChoose(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { queryHousekeepingServConfig } from '@/api/goods/finishHousekeepingPoolApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  data() {
    return {
      dialogVisible: false,
      chooseHousekeepingServFeeInfo: {
        housekeepingServFees: [],
        servId: ''
      }
    }
  },
  methods: {
    open(params) {
      this.chooseHousekeepingServFeeInfo.servId = params.servId
      this._loadHousekeepingServFees()
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleChoose(row) {
      this.$emit('chooseHousekeepingServFee', row)
      this.dialogVisible = false
    },
    _loadHousekeepingServFees() {
      let shopId = getShopId()
      queryHousekeepingServConfig({
        page: 1,
        row: 10,
        shopId: shopId,
        servId: this.chooseHousekeepingServFeeInfo.servId
      }).then(res => {
        this.chooseHousekeepingServFeeInfo.housekeepingServFees = res.data
      }).catch(err => {
        console.error('请求失败:', err)
      })
    }
  }
}
</script>

<style scoped>
.el-dialog__body {
  padding: 20px;
}
</style>